module.exports = __webpack_public_path__ + "static/media/back.ea9ea9cf.svg";